import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import {
  catchError,
  filter,
  map,
  mergeMap,
  withLatestFrom,
} from 'rxjs/operators';
import { EMPTY, of } from 'rxjs';
import { Store } from '@ngrx/store';
import {
  loadSousSystemesAction,
  loadSousSystemesSuccessAction,
  getIsSousSystemeInitialized,
  SousSystemeState,
  loadSousSystemesErrorAction,
} from './sous-systeme.store';
import { SousSystemeService } from '../../_services/http/sous-systeme.service';

@Injectable()
export class SousSystemeEffect {
  constructor(
    private service: SousSystemeService,
    private actions$: Actions,
    private store: Store<SousSystemeState>
  ) {}

  load$ = createEffect(() =>
    this.actions$.pipe(
      ofType(loadSousSystemesAction),
      withLatestFrom(this.store.select(getIsSousSystemeInitialized)),
      filter(([action, isInitialized]) => !isInitialized),
      mergeMap(() =>
        this.service.all().pipe(
          map((payload) => loadSousSystemesSuccessAction({ payload })),
          catchError(() => of(loadSousSystemesErrorAction()))
        )
      )
    )
  );
}
